import { SearchBox } from '#src/app/pages/searchV2/shared/components';

import { SearchQueryResultText } from './components/SearchQueryResultText';
import { SearchResult } from './components/SearchResult';

export const ResultsPageLayout: React.FC = () => {
	return (
		<>
			<div className="mt-4 md:mt-16">
				<SearchBox />
				<SearchQueryResultText />
			</div>
			<SearchResult />
		</>
	);
};
